import { useMutation } from '@tanstack/react-query';
import graphqlClient from '@/graphql/graphql-client';

import type { InsertOrganizationMutation, InsertOrganizationMutationVariables } from '@/graphql/generated/graphql';
import { InsertOrganizationDocument } from '@/graphql/generated/graphql';
export type InsertOrganizationPayload = {
  Name: string;
  Slug: string;
  LogoUrl: string;
  MaxUsers: number;
  MaxTemplates: number;
  SeliseClientId: string;
  SeliseClientSecret: string;
  BlocksOrgId: string;
  SigOrgId: string;
};

export type InsertOrganizationResult = {
  acknowledged: boolean;
  itemId: string | null;
  totalImpactedData: number;
  message?: string | null;
};

export type InsertOrganizationResponse = {
  insertOrganizations: InsertOrganizationResult;
};

export const useInsertOrganization = () => {
  const mutation = useMutation({
    mutationKey: ['insert-organization'],
    mutationFn: (variables: InsertOrganizationPayload) => {
      return graphqlClient.request<InsertOrganizationMutation>(InsertOrganizationDocument,
        variables
      );
    },
  });

  return {
    ...mutation,
    insertOrganization: mutation.mutate,
    insertOrganizationAsync: mutation.mutateAsync,
  };
};

export const INSERT_ORGANIZATION_MUTATION = InsertOrganizationDocument;
